import httpClient from '@/api/httpClient'
import _ from 'lodash'
import Constant from '@/constant/index'

const state = {
  baseForm: {
    ShipName: '',
    BuildYear: '',
    ShipType: '',
    Flag: '',
    Draft: '',
    DWT: '',
    GRT: '',
    NRT: '',
    ShipLength: '',
    Breadth: '',
    Depth: '',
    DWCC: ''
  },
  fuelForm: {
    FOType: '',
    DOType: '',
    LSFOType: '',
    LSDOType: '',

    BallastFullSpeed: '',
    LadenFullSpeed: '',
    BallastEcoSpeed: '',
    LadenEcoSpeed: '',

    FOFullBallast: '',
    LSFOFullBallast: '',
    FOPortIdle: '',
    LSFOPortIdle: '',
    FOEcoBallast: '',
    LSFOEcoBallast: '',
    DOPortIdle: '',
    LSDOPortIdle: '',
    FOFullLaden: '',
    LSFOFullLaden: '',
    FOPortWork: '',
    LSFOPortWork: '',
    FOEcoLaden: '',
    LSFOEcoLaden: '',
    DOPortWork: '',
    LSDOPortWork: '',
    DOLaden: '',
    LSDOLaden: ''
  },
  otherForm: {
    GrainCapacity: '',
    BaleCapacity: '',
    HoldNum: '',
    HatchNum: '',
    DeckNum: '',
    HatchType: '',
    HatchSize: '',
    HoldSize: '',
    GearDesc: '',

    IMOCode: '',
    CallSign: '',
    PAndI: '',
    ShipClass: '',
    SSDate: '',
    DDDate: '',
    MainEngine: '',
    Shipyard: ''
  }
}

// getters
const getters = {

}

// actions
const actions = {

} // end actions

// mutations
const mutations = {
  setBaseForm (state, payload) {
    state.baseForm = _.cloneDeep(payload)
  },
  setFuelForm (state, payload) {
    state.fuelForm = _.cloneDeep(payload)
  },
  setOtherForm (state, payload) {
    state.otherForm = payload
  },

  resetVesselFormEmpty (state, payload = {}) {
    for (const [key, value] of Object.entries(state.baseForm)) {
      state.baseForm[key] = ''
    }
    for (const [key, value] of Object.entries(state.fuelForm)) {
      state.fuelForm[key] = ''
    }
    for (const [key, value] of Object.entries(state.otherForm)) {
      state.otherForm[key] = ''
    }
  },

  setVesselSSDate (state, payload) {
    state.otherForm.SSDate = payload
  },
  setVesselDDDate (state, payload) {
    state.otherForm.DDDate = payload
  }

}

export default {
  state,
  getters,
  mutations,
  actions
}
